<template>
  <div class="tools">
    <div class="button-group gutter-0">
      <StoryblokComponent
        v-for="item in headerSecondary"
        :key="item._uid"
        :blok="item"
        anchor-class="button button--sm button--reverse rounded-sm"
      />
    </div>
    <WeglotLanguageSwitcher />
    <div class="button-group gutter-0">
      <div
        aria-label="Increase Font Size"
        class="button button--xs button--reverse rounded-sm"
        @click="increaseSize"
      >
        <i class="icon icon--lg">
          <Icon name="fa6-solid:font" />
        </i>
        <i class="icon icon--sm">
          <Icon name="fa6-solid:plus" />
        </i>
        <span class="sr-only"> Increase Font Size </span>
      </div>
      <div
        aria-label="Decrease Font Size"
        class="button button--xs button--reverse rounded-sm"
        @click="decreaseSize"
      >
        <i class="icon icon--lg">
          <Icon name="fa6-solid:font" />
        </i>
        <i class="icon icon--sm">
          <Icon name="fa6-solid:minus" />
        </i>
        <span class="sr-only"> Decrease Font Size </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { navigationMenu } = await useConfigStore()
const headerSecondary = computed(() => navigationMenu?.header_secondary)
const sizes = ref(['xxs', 'xs', 'sm', 'default', 'lg', 'xl', 'xxl'])
const currentSize = ref(3)

useEventListener('keydown', (e) => {
  if (e.metaKey && e.key === '+') increaseSize()
  if (e.metaKey && e.key === '-') decreaseSize()
})

function increaseSize() {
  if (currentSize.value < sizes.value.length - 1) {
    clearSize()
    currentSize.value++
    setSize()
  }
}

function decreaseSize() {
  if (currentSize.value > 0) {
    clearSize()
    currentSize.value--
    setSize()
  }
}

function clearSize() {
  document.documentElement.classList.remove(
    'scale--text-' + sizes.value[currentSize.value],
  )
}

function setSize() {
  document.documentElement.classList.add(
    'scale--text-' + sizes.value[currentSize.value],
  )
}
</script>

<style lang="less" scoped>
.tools {
  .flex();

  padding-right: @gutter-sm;

  > .button-group:first-of-type {
    padding-right: @gutter-sm;
  }

  .button--reverse {
    color: @color-secondary;
  }
}
</style>
